import { ISearchService } from '../../types';
import HandleSearch from './methods/HandleSearch';
import GetFilters from './methods/GetFilters';
import GetProductResults from './methods/GetProductResults';
import GetCmsContent from './methods/GetCmsContent';

/**
 * ShopifySearch
 *
 * ISearchService-compatible provider that uses Shopify's native search
 * (which is configured/augmented by the Search & Discovery app)
 * instead of a third-party API like Boost.
 *
 * NOTE: The individual methods call theme JSON views such as:
 *   - /search?view=app-layer-search
 *   - /search?view=app-layer-cms
 * which must be implemented in Liquid.
 */
const ShopifySearch: ISearchService = {
  methods: {
    handleSearch: HandleSearch,
    getFilters: GetFilters,
    getProductResults: GetProductResults,
    getCmsContent: GetCmsContent,
  },
};

export default ShopifySearch;

